<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('dealType')">
          <el-select
            v-model="queryForm.businessCode"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="item in businessList"
              :key="item.id"
              :label="$t(item.name)"
              :value="item.businessCode"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('region')">
          <el-select v-model="queryForm.region" size="small">
            <el-option :label="$t('all')" value=""></el-option>
            <template v-for="(item, index) in countryList">
              <el-option-group
                v-if="item.parentId == 0"
                :key="index"
                :label="item.name"
              >
                <template v-for="(it, i) in countryList">
                  <el-option
                    v-if="it.parentId == item.id"
                    :key="i + index.toString()"
                    :label="it.name"
                    :value="it.id"
                  ></el-option>
                </template>
              </el-option-group>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('phone')">
          <el-input v-model="queryForm.phoneNo" size="small"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isloading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isloading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column class-name="multiple-header-intervals">
          <el-table-column prop="id" :label="$t('ID')" min-width="100">
          </el-table-column>

          <el-table-column
            prop="customerName"
            :label="$t('customer')"
            min-width="200"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.customerName }}</template
            >
          </el-table-column>

          <el-table-column prop="phoneNo" :label="$t('phone')" min-width="100">
          </el-table-column>

          <el-table-column prop="amount" :label="$t('amount')" min-width="160">
            <template slot-scope="scope"
              ><span class="franc">₣</span>
              {{
                String(scope.row.amount || "")
                  .replace("-", "")
                  .split(".")[0]
                  .formatMoney(0)
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="transactionCode"
            :label="$t('transactionCode')"
            min-width="200"
          >
          </el-table-column>

          <el-table-column
            prop="businessName"
            :label="$t('businessName')"
            min-width="180"
          >
            <template slot-scope="scope">{{
              $t(scope.row.businessName)
            }}</template>
          </el-table-column>

          <el-table-column prop="status" :label="$t('status')" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" class="text-warning">{{
                $t("remittor")
              }}</span>
              <span v-else class="text-primary">{{ $t("Payee") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('creationTime')"
            min-width="160"
          >
            <template slot-scope="scope">{{
              $manba(scope.row.createTime).format("ymdhms")
            }}</template>
          </el-table-column>
          <el-table-column
            prop="orgName"
            :label="$t('operateOrg')"
            min-width="180"
          >
          </el-table-column>

          <el-table-column
            prop="creatorName"
            :label="$t('creatorName')"
            min-width="160"
          >
            <template slot-scope="scope">{{
              scope.row.orgUserName + " " + scope.row.orgUserSurname
            }}</template>
          </el-table-column>

          <el-table-column
            prop="createId"
            :label="$t('createId')"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="country"
            :label="$t('nation') + ' / ' + $t('region')"
            width="220"
          >
            <template slot-scope="scope">
              {{ getNationProvinceUrban(scope.row) }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />
  </el-card>
</template>

<script>
//import org from '@/api/org'
import monitoring from "@/api/monitoring";
import business from "@/api/business";
export default {
  name: "monitoring",
  data() {
    return {
      queryForm: { customerType: 1 },
      businessList: [],
      // queryForm: { queryObject: 1 },
      queryTableHeight: String,

      tableData: {},
      pageSize: 20,
      currentPage: 1,
      isloading: false,

      editVisible: false,
      editForm: {},
      surplusTime: 0,
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: time => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        }
      }
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    cascader() {
      return this.$store.state.format.cascader;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    rules() {
      return {};
    }
  },
  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    }
  },

  methods: {
    getNationProvinceUrban(row) {
      let c = this.countryList.find(function(c) {
        return row.country == c.id;
      });
      let r = this.countryList.find(function(c) {
        return row.region == c.id;
      });
      let cr = (c ? c.name : "") + " / " + (r ? r.name : "");
      return cr;
    },
    getList() {
      let _this = this;
      _this.tableData.records = [];
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      monitoring.getPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ...params
        },
        success: res => {
          if (res.code == 200) {
            _this.isLoading = false;
            _this.tableData = res.data || {};
          } else {
            _this.$message.warning(_this.$t(res.msg || "operationFailure"));
          }
        }
      });
    },
    getBusiness() {
      let _this = this;
      business.getTransactionList({
        success: res => {
          //console.log("Data: ", res.data.reverse());
          _this.businessList = res.data.reverse();
          _this.getList();
        }
      });
    },

    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: time => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          }
        };
      }
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    visibleEdit(row) {
      this.editForm = row;
      this.editForm.country_region_city = [
        Number(row.country),
        Number(row.region),
        Number(row.city)
      ];
      this.editVisible = true;
    }
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";

    this.getList();

    this.getBusiness();
  }
};
</script>
<style lang="less"></style>
